(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buya-transparent-header"] && !Shopify.designMode) return;
  try {
    (() => {
    function initializeBuyaHeader() {
      if (!document.getElementById('buya-home-header-marker')) return;

      const header = document.querySelector('.section-header');
      if (!header || header.classList.contains('buya-overlay-header')) return;

      const precedingSections = [];
      let section = header.previousElementSibling;

      while (
        section &&
        section.classList.contains('shopify-section-group-header-group')
      ) {
        precedingSections.push(section);
        section = section.previousElementSibling;
      }

      let offset = 0;

      function update() {
        header.style.setProperty(
          '--buya-header-top',
          `${Math.max(0, offset - window.scrollY)}px`
        );

        header.classList.toggle(
          'buya-header-solid',
          window.scrollY > 24
        );
      }

      function measure() {
        offset = precedingSections.reduce(
          (height, item) => height + item.getBoundingClientRect().height,
          0
        );
        update();
      }

      header.classList.add('buya-overlay-header');
      measure();

      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', measure, { passive: true });

      if (window.ResizeObserver) {
        const observer = new ResizeObserver(measure);
        precedingSections.forEach(item => observer.observe(item));
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initializeBuyaHeader,
        { once: true }
      );
    } else {
      initializeBuyaHeader();
    }

    document.addEventListener(
      'shopify:section:load',
      initializeBuyaHeader
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
